import { useBeforeUnload } from 'helpers/hooks';

const BrowserPrompt = ({ when }) => {
  useBeforeUnload({ when });
  return null;
};

export default BrowserPrompt;
